import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router';

export const ScrollToTop = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType !== 'POP') {
      window.scrollTo({ left: 0, top: 0 });
    }
  }, [location, navigationType]);

  return null;
};
